import { Box } from '@primer/react';
import LiveCheckinPage from './pages/live-checkin';
import LiveCheckinPublicPage from './pages/live-checkin-public';

const PubicContent = () => {
    const path = window.location.pathname;
    return (
        <Box>
            {path.includes("live-checkin-private") ? <LiveCheckinPage /> : <LiveCheckinPublicPage />}
        </Box>

    );
};

export default PubicContent;